module.exports = __webpack_public_path__ + "img/ltktrendingcreators-2x.2bd9913.jpg";